import { ColumnSort } from '@tanstack/react-table';

import { ISort } from '@t/api/common/sort.model';

export const convertSorts = <TData = unknown>(sorts: ISort<TData>[] | undefined) => {
  return (
    sorts?.map(({ direction, field: id }) => {
      return {
        desc: direction === 'desc',
        id,
      } as ColumnSort;
    }) ?? []
  );
};
